<script setup lang="ts">
  interface Option {
    id: string | number;
    name: string;
    disabled?: boolean;
  }

  defineProps<{
    modelValue: string | number;
    options: Option[];
    idPrefix?: string;
    activeIndex?: number;
  }>();

  const emit = defineEmits<{
    select: [option: Option];
  }>();
</script>

<template>
  <div
    v-for="(option, index) in options"
    :id="idPrefix ? `${idPrefix}-${index}` : undefined"
    :key="option.id"
    role="option"
    :aria-selected="String(option.id) === String(modelValue)"
    :aria-disabled="option.disabled ? true : undefined"
    :class="[
      'px-3 py-2 cursor-pointer text-sm font-normal text-gray-07 rounded-lg hover:bg-off-white transition-colors duration-150',
      String(option.id) === String(modelValue) ? 'bg-gray-02' : '',
      index === activeIndex ? 'bg-off-white ring-2 ring-inset ring-gray-03' : '',
      option.disabled ? 'opacity-50 cursor-not-allowed' : '',
    ]"
    @click="emit('select', option)"
  >
    {{ option.name }}
  </div>
</template>
